import { takeEvery, call, put } from "redux-saga/effects";
import actionTypes from "_constants/actionTypes";
import { xcService } from "_services/xcService";
import endpoint from "shared/endpoints";

export default function* watcherQuestionnaireSaga() {
    yield takeEvery(actionTypes.GET_QUESTIONNAIRES, getQuestionnaires);
    yield takeEvery(actionTypes.GET_QUESTIONNAIRE, getQuestionnaire);
    yield takeEvery(actionTypes.GET_ASSESSMENTS, getAssestments);
    yield takeEvery(actionTypes.GET_ASSESSMENTS_CODE, getAssestmentsCode);
    yield takeEvery(actionTypes.SAVE_ANSWER, saveAnswer);
    yield takeEvery(actionTypes.SAVE_AREA, saveArea);
    yield takeEvery(actionTypes.DELETE_ANSWER, deleteAnswer);

    yield takeEvery(actionTypes.GET_ANSWERS, getAnswers);
    yield takeEvery(actionTypes.GET_ANSWERS_V2, getAnswersV2);
    yield takeEvery(actionTypes.GET_AREA_STUDENT, getArea);
    yield takeEvery(actionTypes.GET_RESPONSES, getResponses);
    yield takeEvery(actionTypes.GET_RESPONSE, getResponse);
}

function* getResponses({payload}) {
    yield put({ type: actionTypes.START_REQUEST });
    try {
        let apiEndpoint = `/v1/response/assessment/${payload}`;
        const res = yield call(
            () =>
                new Promise((resolve, reject) => {
                    xcService.getToken(apiEndpoint).then((response) => {
                        resolve(response);
                    });
                })
        );
        if (res.status === 200) {
            yield put({
                type: actionTypes.GET_RESPONSES_DATA,
                payload: res.data.data,
            });
        }/* else {
            yield put({
                type: actionTypes.GET_AREA_STUDENT_ERROR,
                payload: res.data,
            });
        }*/

    } catch (e) {
        //yield put({ type: actionTypes.GET_AREA_STUDENT_ERROR, payload: e });

    }
    yield put({ type: actionTypes.END_REQUEST });
}

function* getResponse({payload}) {
    yield put({ type: actionTypes.START_REQUEST });
    try {
        let apiEndpoint = `/v1/response/${payload}`;
        const res = yield call(
            () =>
                new Promise((resolve, reject) => {
                    xcService.getToken(apiEndpoint).then((response) => {
                        resolve(response);
                    });
                })
        );
        if (res.status === 200) {
            yield put({
                type: actionTypes.GET_RESPONSE_DATA,
                payload: res.data.data,
            });
        }/* else {
            yield put({
                type: actionTypes.GET_AREA_STUDENT_ERROR,
                payload: res.data,
            });
        }*/

    } catch (e) {
        //yield put({ type: actionTypes.GET_AREA_STUDENT_ERROR, payload: e });

    }
    yield put({ type: actionTypes.END_REQUEST });
}

function* getArea(payload) {


    yield put({ type: actionTypes.START_REQUEST });
    try {
        let apiEndpoint = "/v1/student/area/" + payload.payload;
        if (!payload.payload) {
            yield put({
                type: actionTypes.GET_AREA_STUDENT_ERROR,
                payload: 'Área no proporcionada',
            });
            return;
        }
        const res = yield call(
            () =>
                new Promise((resolve, reject) => {
                    xcService.getToken(apiEndpoint).then((response) => {
                        resolve(response);
                    });
                })
        );
        if (res.status === 200) {
            yield put({
                type: actionTypes.GET_AREA_STUDENT_DATA,
                payload: res.data.data,
            });
        } else {
            yield put({
                type: actionTypes.GET_AREA_STUDENT_ERROR,
                payload: res.data,
            });
        }

    } catch (e) {
        yield put({ type: actionTypes.GET_AREA_STUDENT_ERROR, payload: e });

    }
    yield put({ type: actionTypes.END_REQUEST });
}
function* deleteAnswer({payload}) {
    yield put({ type: actionTypes.START_REQUEST });
    try {
        let apiEndpoint = "/v1/student/assessments/answer/delete";
        const res = yield call(
            () =>
                new Promise((resolve, reject) => {
                    xcService.putToken(apiEndpoint, payload).then((response) => {
                        resolve(response);
                    });
                })
        );

    } catch (e) {


    }
    yield put({ type: actionTypes.DELETE_ANSWER_DATA, payload:"deleted" });
    yield put({ type: actionTypes.CLEAR_DELETE_ANSWER_DATA, payload:"deleted" });
}

function* saveArea({payload}) {
    yield put({ type: actionTypes.START_REQUEST });
    try {
        let apiEndpoint = "/v1/student/save/area";
        const res = yield call(
            () =>
                new Promise((resolve, reject) => {
                    xcService.postToken(apiEndpoint, payload).then((response) => {
                        resolve(response);
                    });
                })
        );
        if (res.status === 200) {
            yield put({
                type: actionTypes.SAVE_AREA_DATA,
                payload: res.data.data,
            });
        } else {
            yield put({
                type: actionTypes.SAVE_AREA_ERROR,
                payload: res.data,
            });
        }

        yield put({
            type: actionTypes.CLEAR_SAVE_AREA,
            payload: "clear",
        });

    } catch (e) {
        yield put({ type: actionTypes.SAVE_AREA_ERROR, payload: e });
        yield put({
            type: actionTypes.CLEAR_SAVE_AREA,
            payload: "clear",
        });

    }
    yield put({ type: actionTypes.END_REQUEST });
}

function* getAnswers(payload) {
    yield put({ type: actionTypes.START_REQUEST });
    try {
        let apiEndpoint = endpoint.studentAnswer.getAll(payload.payload, {query: {withResponses: true}});
        const res = yield call(
            () =>
                new Promise((resolve, reject) => {
                    xcService.getToken(apiEndpoint).then((response) => {
                        resolve(response);
                    });
                })
        );
        if (res.status === 200) {
            yield put({
                type: actionTypes.GET_ANSWERS_DATA,
                payload: res.data.data,
            });
        } else {
            yield put({
                type: actionTypes.GET_ANSWERS_ERROR,
                payload: res.data,
            });
        }

    } catch (e) {
        yield put({ type: actionTypes.GET_ANSWERS_ERROR, payload: e });

    }
    yield put({ type: actionTypes.CLEAR_DATA_ANSWER });
    yield put({ type: actionTypes.END_REQUEST });
}

function* getAnswersV2(payload) {
    yield put({ type: actionTypes.START_REQUEST });
    try {
        let apiEndpoint = endpoint.v2.studentAnswer.getAll(payload.payload, {query: {withResponses: true}});
        const res = yield call(
            () =>
                new Promise((resolve, reject) => {
                    xcService.getToken(apiEndpoint).then((response) => {
                        resolve(response);
                    });
                })
        );
        if (res.status === 200) {
            yield put({
                type: actionTypes.GET_ANSWERS_DATA_V2,
                payload: res.data.data,
            });
        } else {
            yield put({
                type: actionTypes.GET_ANSWERS_ERROR,
                payload: res.data,
            });
        }

    } catch (e) {
        yield put({ type: actionTypes.GET_ANSWERS_ERROR, payload: e });

    }
    yield put({ type: actionTypes.CLEAR_DATA_ANSWER });
    yield put({ type: actionTypes.END_REQUEST });
}

function* saveAnswer({payload}) {
    yield put({ type: actionTypes.START_REQUEST });
    try {
        let apiEndpoint = "/v1/student/assessments/answer";
        const res = yield call(
            () =>
                new Promise((resolve, reject) => {
                    xcService.postToken(apiEndpoint, payload).then((response) => {
                        resolve(response);
                    });
                })
        );
        if (res.status === 200) {
            yield put({
                type: actionTypes.SAVE_ANSWER_DATA,
                payload: res.data.data,
            });
        } else {
            yield put({
                type: actionTypes.SAVE_ANSWER_ERROR,
                payload: res.data,
            });
        }

        yield put({
            type: actionTypes.CLEAR_ANSWER,
            payload: "clear",
        });

    } catch (e) {
        yield put({ type: actionTypes.SAVE_ANSWER_ERROR, payload: e });
        yield put({
            type: actionTypes.CLEAR_ANSWER,
            payload: "clear",
        });

    }
    yield put({ type: actionTypes.END_REQUEST });
}

function* getAssestmentsCode(payload) {
    yield put({ type: actionTypes.START_REQUEST });
    try {
        let apiEndpoint = "/v1/student/assessments/" + payload.payload;
        const res = yield call(
            () =>
                new Promise((resolve, reject) => {
                    xcService.getToken(apiEndpoint).then((response) => {
                        resolve(response);
                    });
                })
        );
        if (res.status === 200) {
            yield put({
                type: actionTypes.GET_ASSESSMENTS_CODE_DATA,
                payload: res.data.data,
            });
        } else {
            yield put({
                type: actionTypes.GET_ASSESSMENTS_CODE_ERROR,
                payload: res.data,
            });
        }

    } catch (e) {
        yield put({ type: actionTypes.GET_ASSESSMENTS_CODE_ERROR, payload: e });

    }
    yield put({ type: actionTypes.CLEAR_ASSESSMENTS_CODE });
    yield put({ type: actionTypes.END_REQUEST });
}


function* getAssestments(payload) {
    yield put({ type: actionTypes.START_REQUEST });
    try {
        let apiEndpoint = "/v1/student/questionnaires/assessments/" + payload.payload;
        const res = yield call(
            () =>
                new Promise((resolve, reject) => {
                    xcService.getToken(apiEndpoint).then((response) => {
                        resolve(response);
                    });
                })
        );
        if (res.status === 200) {
            yield put({
                type: actionTypes.GET_ASSESSMENTS_DATA,
                payload: res.data.data,
            });
        } else {
            yield put({
                type: actionTypes.GET_ASSESSMENTS_ERROR,
                payload: res.data,
            });
        }

    } catch (e) {
        yield put({ type: actionTypes.GET_ASSESSMENTS_ERROR, payload: e });

    }
    yield put({ type: actionTypes.END_REQUEST });
}

function* getQuestionnaires(payload) {
    yield put({ type: actionTypes.START_REQUEST });

    try {
        let apiEndpoint = "/v1/student/questionnaires";
        const res = yield call(
            () =>
                new Promise((resolve, reject) => {
                    xcService.getToken(apiEndpoint).then((response) => {
                        resolve(response);
                    });
                })
        );
        if (res.status === 200) {
            yield put({
                type: actionTypes.GET_QUESTIONNAIRES_DATA,
                payload: res.data.data,
            });
        } else {
            yield put({
                type: actionTypes.GET_QUESTIONNAIRES_ERROR,
                payload: res.data,
            });
        }

    } catch (e) {
        yield put({ type: actionTypes.GET_QUESTIONNAIRES_ERROR, payload: e });

    }
    yield put({ type: actionTypes.END_REQUEST });
}



function* getQuestionnaire(payload) {
    yield put({ type: actionTypes.START_REQUEST });

    try {
        let apiEndpoint = "/v1/student/questionnaire/" + payload.payload;
        const res = yield call(
            () =>
                new Promise((resolve, reject) => {
                    xcService.getToken(apiEndpoint).then((response) => {
                        resolve(response);
                    });
                })
        );
        if (res.status === 200) {
            yield put({
                type: actionTypes.GET_QUESTIONNAIRE_DATA,
                payload: res.data.data,
            });
        } else {
            yield put({
                type: actionTypes.GET_QUESTIONNAIRE_ERROR,
                payload: res.data,
            });
        }
        yield put({
            type: actionTypes.CLEAR_QUESTIONNAIRE_DATA,
            payload: null,
        });
    } catch (e) {
        yield put({ type: actionTypes.GET_QUESTIONNAIRE_ERROR, payload: e });
        yield put({
            type: actionTypes.CLEAR_QUESTIONNAIRE_DATA,
            payload: null,
        });
    }
    yield put({ type: actionTypes.END_REQUEST });
}
